import moment from "moment";
import axios, { AxiosRequestConfig, AxiosResponse, AxiosError } from "axios";
import { getCookie } from "utils/v3/CookieUtil";

export const convertToDateFormat = (date: string | Date): string => {
  return moment(date).format("YYYY-MM-DD");
};

/**
 * PATCH `/member` expects `dob` as `YYYY-MM-DD`. Login scrape stores `dob` as
 * `MM/DD/YYYY` via {@link getMemberData}; HTML date inputs emit `YYYY-MM-DD`.
 */
export function normalizeMemberDobForPatch(
  dob: string | undefined | null
): string {
  if (dob == null) return "";
  const trimmed = String(dob).trim();
  if (!trimmed) return "";
  const parsed = moment(trimmed, ["YYYY-MM-DD", "MM/DD/YYYY", "M/D/YYYY"], true);
  if (parsed.isValid()) {
    return parsed.format("YYYY-MM-DD");
  }
  const loose = moment(trimmed);
  return loose.isValid() ? loose.format("YYYY-MM-DD") : trimmed;
}

export function formatDateStringForBackEnd(dateString: string): string {
  const parts = dateString.split("/");
  const year = parts[2];
  const month = parts[0].padStart(2, "0");
  const day = parts[1].padStart(2, "0");
  return `${year}-${month}-${day}`;
}

export function doApiCall(
  request: AxiosRequestConfig
): Promise<AxiosResponse | AxiosError> {
  const accessToken = getCookie("accessToken");
  request.headers = {
    ...request.headers,
    "content-type": "application/json",
    authorization: accessToken
  };

  return axios(request)
    .then((data: AxiosResponse) => data)
    .catch((error: AxiosError) => error);
}
